export default {
  scentType: {
    en: 'Scent type',
  },
  scentPersonality: {
    en: 'Scent personality',
  },
  occasion: {
    en: 'Occasion',
  },
  style: {
    en: 'Style',
  },
  season: {
    en: 'Season',
  },
  other: {
    en: 'Other',
  },
}
